import AppWrapper from "./components/AppWrapper";
import StudentList from "./components/StudentList";

function App() {
  return (
    <AppWrapper>
      <StudentList />
    </AppWrapper>
  );
}

export default App;
